var _path, _path2, _circle, _filter, _clipPath, _filter2, _clipPath2, _filter3, _clipPath3, _clipPath4, _filter4, _clipPath5, _filter5, _clipPath6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessSetup(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#F0F6FE",
    style: {
      fill: "#F0F6FE",
      fill: "color(display-p3 0.9412 0.9647 0.9961)",
      fillOpacity: 1
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 29H47V43C47 44.1046 46.1046 45 45 45H19C17.8954 45 17 44.1046 17 43V29Z",
    fill: "url(#paint0_linear_6764_129050)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.2554 20.1345C18.5883 19.4411 19.2893 19 20.0585 19H43.9415C44.7107 19 45.4117 19.4411 45.7446 20.1345L49.3123 27.5673C49.6309 28.2311 49.1471 29 48.4108 29H15.5892C14.8529 29 14.3691 28.2311 14.6877 27.5673L18.2554 20.1345Z",
    fill: "#D9D9D9",
    style: {
      fill: "#D9D9D9",
      fill: "color(display-p3 0.8510 0.8510 0.8510)",
      fillOpacity: 1
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2554 20.1345C18.5883 19.4411 19.2893 19 20.0585 19H43.9415C44.7107 19 45.4117 19.4411 45.7446 20.1345L49.3123 27.5673C49.6309 28.2311 49.1471 29 48.4108 29H15.5892C14.8529 29 14.3691 28.2311 14.6877 27.5673L18.2554 20.1345Z",
    fill: "url(#paint1_linear_6764_129050)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 16,
    y: 28,
    width: 17,
    height: 18
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.5px)",
      clipPath: "url(#bgblur_0_6764_129050_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6764_129050)",
    "data-figma-bg-blur-radius": 5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 36.5C21 34.567 22.567 33 24.5 33C26.433 33 28 34.567 28 36.5V40C28 40.5523 27.5523 41 27 41H22C21.4477 41 21 40.5523 21 40V36.5Z",
    fill: "white",
    fillOpacity: 0.8,
    style: {
      fill: "white",
      fillOpacity: 0.8
    },
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 29,
    y: 28,
    width: 14,
    height: 14
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.5px)",
      clipPath: "url(#bgblur_1_6764_129050_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6764_129050)",
    "data-figma-bg-blur-radius": 5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 33,
    width: 4,
    height: 4,
    rx: 1,
    fill: "white",
    fillOpacity: 0.8,
    style: {
      fill: "white",
      fillOpacity: 0.8
    },
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 35,
    y: 28,
    width: 14,
    height: 14
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.5px)",
      clipPath: "url(#bgblur_2_6764_129050_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_6764_129050)",
    "data-figma-bg-blur-radius": 5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 33,
    width: 4,
    height: 4,
    rx: 1,
    fill: "white",
    fillOpacity: 0.8,
    style: {
      fill: "white",
      fillOpacity: 0.8
    },
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 25.8501,
    y: 4.85156,
    width: 28.2998,
    height: 28.2969
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(3px)",
      clipPath: "url(#bgblur_3_6764_129050_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-figma-bg-blur-radius": 6,
    cx: 40,
    cy: 19,
    r: 8,
    fill: "url(#paint2_linear_6764_129050)",
    stroke: "url(#paint3_linear_6764_129050)",
    strokeOpacity: 0.17,
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 33,
    y: 13,
    width: 14,
    height: 17
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.5px)",
      clipPath: "url(#bgblur_4_6764_129050_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_6764_129050)",
    "data-figma-bg-blur-radius": 5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 18,
    width: 4,
    height: 7,
    rx: 2,
    fill: "white",
    fillOpacity: 0.5,
    style: {
      fill: "white",
      fillOpacity: 0.5
    },
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 33,
    y: 8,
    width: 14,
    height: 14
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.5px)",
      clipPath: "url(#bgblur_5_6764_129050_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_6764_129050)",
    "data-figma-bg-blur-radius": 5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 15,
    r: 2,
    fill: "white",
    fillOpacity: 0.5,
    style: {
      fill: "white",
      fillOpacity: 0.5
    },
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6764_129050",
    x: 16,
    y: 28,
    width: 17,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.249202 0 0 0 0 0.431605 0 0 0 0 0.897743 0 0 0 0.57 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6764_129050"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6764_129050",
    result: "shape"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_6764_129050_clip_path",
    transform: "translate(-16 -28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 36.5C21 34.567 22.567 33 24.5 33C26.433 33 28 34.567 28 36.5V40C28 40.5523 27.5523 41 27 41H22C21.4477 41 21 40.5523 21 40V36.5Z"
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6764_129050",
    x: 29,
    y: 28,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.249202 0 0 0 0 0.431605 0 0 0 0 0.897743 0 0 0 0.57 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6764_129050"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6764_129050",
    result: "shape"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_6764_129050_clip_path",
    transform: "translate(-29 -28)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 33,
    width: 4,
    height: 4,
    rx: 1
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_6764_129050",
    x: 35,
    y: 28,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.249202 0 0 0 0 0.431605 0 0 0 0 0.897743 0 0 0 0.57 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6764_129050"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6764_129050",
    result: "shape"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_6764_129050_clip_path",
    transform: "translate(-35 -28)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 33,
    width: 4,
    height: 4,
    rx: 1
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_3_6764_129050_clip_path",
    transform: "translate(-25.8501 -4.85156)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 19,
    r: 8
  }))), _filter4 || (_filter4 = /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_6764_129050",
    x: 33,
    y: 13,
    width: 14,
    height: 17,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.249202 0 0 0 0 0.431605 0 0 0 0 0.897743 0 0 0 0.57 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6764_129050"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6764_129050",
    result: "shape"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_4_6764_129050_clip_path",
    transform: "translate(-33 -13)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 18,
    width: 4,
    height: 7,
    rx: 2
  }))), _filter5 || (_filter5 = /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_6764_129050",
    x: 33,
    y: 8,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.249202 0 0 0 0 0.431605 0 0 0 0 0.897743 0 0 0 0.57 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6764_129050"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6764_129050",
    result: "shape"
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_5_6764_129050_clip_path",
    transform: "translate(-33 -8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 15,
    r: 2
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6764_129050",
    x1: 24.5,
    y1: 30,
    x2: 44.1812,
    y2: 32.1408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B72FF",
    style: {
      stopColor: "#3B72FF",
      stopColor: "color(display-p3 0.2326 0.4489 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2361FF",
    style: {
      stopColor: "#2361FF",
      stopColor: "color(display-p3 0.1376 0.3791 0.9982)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6764_129050",
    x1: 23,
    y1: 24,
    x2: 28.4353,
    y2: 38.3934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C95FF",
    style: {
      stopColor: "#6C95FF",
      stopColor: "color(display-p3 0.4219 0.5846 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2763FF",
    style: {
      stopColor: "#2763FF",
      stopColor: "color(display-p3 0.1531 0.3893 1.0000)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6764_129050",
    x1: 35,
    y1: 11,
    x2: 40.892,
    y2: 27.0342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D5BB9",
    stopOpacity: 0.4,
    style: {
      stopColor: "#2D5BB9",
      stopColor: "color(display-p3 0.1753 0.3584 0.7245)",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5,
    style: {
      stopColor: "white",
      stopOpacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6764_129050",
    x1: 33.5,
    y1: 11,
    x2: 42.2073,
    y2: 29.8123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004DFF",
    style: {
      stopColor: "#004DFF",
      stopColor: "color(display-p3 0.0010 0.3017 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFDEFF",
    style: {
      stopColor: "#CFDEFF",
      stopColor: "color(display-p3 0.8134 0.8696 1.0000)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessSetup);
export default __webpack_public_path__ + "static/media/business_setup.910fa0bc16b3bde494b2fc71ecfe0570.svg";
export { ForwardRef as ReactComponent };